import { Button, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { media, mediaQueries } = theme;

export const ArticleTileContainer = styled.div`
  display: grid;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 2rem;

  ${mediaQueries.above(media.sm)} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaQueries.above(media.lg)} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const InnerContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${mediaQueries.above(media.sm)} {
    margin: auto;
    max-width: 52rem;
  }

  ${mediaQueries.above(media.md)} {
    max-width: 60rem;
  }

  ${mediaQueries.above(media.lg)} {
    max-width: 75rem;
  }
`;

export const StyledButton = styled(Button)`
  ${mediaQueries.above(media.sm)} {
    width: 20rem;
  }
`;
